import { jsx as _jsx } from "react/jsx-runtime";
import Icon from "../Icon/Icon";
import { IconSizes, IconVariants } from "../../Images/Icon/constants";
import { UserAvatarContainer, StyledUserAvatar, StyledPlaceHolder, StyledAvatarLetter, } from "./UserAvatar.style";
import { UserAvatarSizes, } from "./constants";
import { Contrast } from "../../../types/general.types";
const UserAvatar = ({ avatarSize = UserAvatarSizes.large, imgUrl, iconName = "itaufonts_usuario_perfil", contrast = Contrast.default, letter, }) => {
    const getIconSize = (avatarSize) => {
        switch (avatarSize) {
            case UserAvatarSizes.small: {
                return { size: IconSizes.small };
            }
            case UserAvatarSizes.medium: {
                return { size: IconSizes.medium };
            }
            case UserAvatarSizes.large: {
                return { size: IconSizes.large };
            }
            case UserAvatarSizes.huge: {
                return { size: IconSizes.xlarge };
            }
        }
    };
    const checkPlaceHolderType = () => {
        if (letter) {
            return (_jsx(StyledAvatarLetter, { contrast: contrast, children: letter.substring(0, 2) }));
        }
        else {
            return (_jsx(Icon, { name: iconName, variant: IconVariants.neutral, ...getIconSize(avatarSize) }));
        }
    };
    return (_jsx(UserAvatarContainer, { children: imgUrl ? (_jsx(StyledUserAvatar, { src: imgUrl, alt: "User Avatar", avatarSize: avatarSize })) : (_jsx(StyledPlaceHolder, { avatarSize: avatarSize, contrast: contrast, children: checkPlaceHolderType() })) }));
};
export default UserAvatar;
//# sourceMappingURL=UserAvatar.js.map